export default __webpack_public_path__ + "static/media/132009554_853690182085959_2349258312351742529_n.475d8979.jpg";